import { Geolocation } from '@capacitor/geolocation';

// plugin's methods
const methods = [
	'getCurrentPosition',
	'watchPosition',
	'clearWatch',
	'checkPermissions',
	'requestPermissions',
];

export function useNativeGeolocation () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = Geolocation[name];
		return api;
	}, {});

	return {
		...api,
	};
};
